<template>
  <v-form>
    <v-text-field
      v-model="form.id"
      label="Position"
      prepend-icon="mdi-numeric"
    ></v-text-field>
    <v-text-field
      v-model="form.text"
      label="Text"
      prepend-icon="mdi-card-text-outline"
    ></v-text-field>
    <v-file-input
      v-if="!hasAttachment"
      v-model="file"
      label="Bifoga PDF-dokument"
      accept=".pdf"
      prepend-icon="mdi-paperclip"
      clearable
      @change="onFileChange"
    ></v-file-input>
  </v-form>
</template>

<script>
const form = {
  id: "",
  text: ""
};

export default {
  props: {
    agenda: Object,
    hasAttachment: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: { ...form },
      file: null
    };
  },
  methods: {
    onFileChange() {
      this.$emit("file-selected", this.file);
    },
    resetForm(agenda) {
      if (!agenda) {
        return;
      }
      const data = {
        id: agenda.id,
        text: agenda.text
      };

      this.form = { ...this.form, ...data };
      // Don't reset file on form reset - only on close
    },
    close() {
      this.form = { ...form };
      this.file = null;
      this.$emit("close");
      this.resetForm(this.agenda);
    }
  },
  mounted() {
    this.resetForm(this.agenda);
  }
};
</script>

<style></style>
